import styled from 'styled-components';

export const PriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  margin-top: 20px;
`;

export const CodeFormsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
